module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/shop_sunshouse_01-f2cf6659876183aadac09ea5b4f4c134.png";